
import { useSelector } from 'react-redux';
// import { useGetRolesQuery } from '../store/auth/authService';
import { RootState } from '../store/store';

// const CACHE_ROLES_TIME = 60

const useRolePage = () => {
    const { roles } = useSelector((state: RootState) => state.auth)
    return {
        data: roles
    }
    // return useGetRolesQuery(undefined, {
    //     refetchOnMountOrArgChange: CACHE_ROLES_TIME,
    //     refetchOnFocus: true,
    //     refetchOnReconnect: true,
    // });
}

export default useRolePage